import styled from 'styled-components';
import {
  Tab as UnstyledTab,
  TabList as UnstyledTabList,
  Tabs as UnstyledTabs,
  TabPanel as UnstyledTabPanel,
} from 'react-tabs';
import { Button, lightenDarkenColor } from '../shared/utils/styles';


export const Tabs = styled(UnstyledTabs)`
  border: 1px solid gray;
  background: white;
  max-height: 100%;
  height: 100%;
`;

export const TabList = styled(UnstyledTabList)`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
`;

export const Tab = styled(UnstyledTab).attrs({
  selectedClassName: 'selected',
  disabledClassName: 'disabled',
})`
  flex-grow: 1;
  text-align: center;
  text-transform: uppercase;
  padding: 8px 0;
  list-style: none;
  cursor: pointer;
  color: #666;
  font-weight: bold;
  border-left: 1px solid gray;
  border-bottom: 1px solid gray;
  background-color: #eee;
  &:first-child {
    border-left: none;
  }

  &.selected {
    color: #000;
    background-color: white;
    border-bottom: none;
  }

  &.disabled {
    color: #ccc;
    cursor: not-allowed;
  }
`;

export const TabPanel = styled(UnstyledTabPanel).attrs({
  selectedClassName: 'selected',
})`
  display: none;
  padding: 0px 10px;
  &.selected {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;

Tab.tabsRole = 'Tab';
Tabs.tabsRole = 'Tabs';
TabPanel.tabsRole = 'TabPanel';
TabList.tabsRole = 'TabList';


export const TabButtonContainer = styled.div``;

export const TabButton = styled.button`
  width: ${(props) => props.width};
  background-color: ${(props) => (props.selected ? '#FFFFFF' : '#eee')};
  color: #000000;
  float: left;
  border-top: ${(props) => (props.borderTop ? '1px solid gray' : 'none')};
  border-right: ${(props) => (props.borderRight ? '1px solid gray' : 'none')};
  border-bottom: ${(props) => (props.borderBottom ? '1px solid gray' : 'none')};
  border-left: ${(props) => (props.borderLeft ? '1px solid gray' : 'none')};
  border-radius: 0px;
  outline: none;
  cursor: pointer;
  height: 45px;
  font-size: 0.8em;
  font-weight: bold;
  text-transform: uppercase;
  &:disabled {
    cursor: not-allowed;
  }
  &:hover {
    background-color: #eee;
  }
`;

export const BidIncrementsContainer = styled.div`
  grid-area: binc;
  background-color: #ffffff;
  display: grid;
  gap: 0px;
  grid-template-rows: 30px 1fr;
`;

export const BidIncrementButtonsContainer = styled.div`
  color: #000000;
  display: ${(props) => (props.show ? 'block' : 'none')};
  padding: 15px 0px;
  text-align: center;
  border-bottom: 1px solid gray;
  border-left: 1px solid gray;
  border-right: 1px solid gray;
`;

export const BidIncrementButton = styled(Button)`
  width: 1fr;
  height: 100%;
  position: relative;
  background-color: ${(props) => (props.selected ? '#009E0F' : '#e7e7e7')};
  color: ${(props) => (props.selected ? '#FFFFFF' : '#000000')};
  font-weight: normal;
  font-size: 1.6em;
  &:hover {
    background-color: ${(props) => lightenDarkenColor(props.selected ? '#009E0F' : '#e7e7e7', 20)};
    color: ${(props) => (props.selected ? '#FFFFFF' : '#000000')};
  }
  &:disabled,
  :disabled:hover {
    cursor: not-allowed;
    background-color: ${(props) => (props.connected ? '#009E0F' : '#e7e7e7')};
    color: ${(props) => (props.connected ? '#FFF' : '#666')};
  }
`;

export const HotKeyLabel = styled.div`
  position: absolute;
  bottom: 5px;
  right: 5px;
  font-size: 0.5em;
`;

export const ButtonGrid = styled.div`
  display: grid;
  gap: 5px;
  grid-template-columns: repeat(2, 1fr);
  padding: 5px;
  min-height: 350px;
`;
